var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3082 13.7158V8.327C13.3073 8.26764 13.2956 8.20907 13.2736 8.15473C13.2517 8.1004 13.2201 8.05138 13.1806 8.01066L9.25497 4.11247C9.18264 4.04012 9.08811 4 8.99002 4C8.89193 4 8.79741 4.04012 8.72502 4.11247L4.79946 8.01066C4.75995 8.05138 4.72831 8.1004 4.7064 8.15473C4.68449 8.20907 4.67275 8.26764 4.67188 8.327V13.7158",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58984 13.7148H21.4022",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0653 13.7154V10.8816C10.0653 10.7743 10.0274 10.6713 9.95991 10.5954C9.89245 10.5194 9.80091 10.4768 9.70548 10.4768H8.2661C8.17066 10.4768 8.07912 10.5194 8.01165 10.5954C7.94416 10.6713 7.90625 10.7743 7.90625 10.8816V13.7154",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1208 14.0989H18.2878L18.2809 4.57764H17.1133L17.1208 14.0989Z",
    fill: "#2B363D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2993 7.35967C16.7684 7.8174 15.88 8.17091 14.9928 8.202L14.8281 8.20488V7.05337C16.1604 7.05337 16.868 6.31756 17.0926 5.20463L17.1047 5.13036C17.1127 5.06818 17.1173 5.00139 17.1196 4.93691L17.1173 4.88336L17.1196 4.72676L17.1185 4.57764",
    fill: "#2B363D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0678 7.32318C18.6314 7.80911 19.5964 8.20178 20.5625 8.20178V7.05027L20.4272 7.04854C19.1824 7.00018 18.5145 6.27704 18.2981 5.20211L18.2693 5.07544H17.8242L18.0678 7.32318Z",
    fill: "#2B363D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1001 8.31616L17.1196 8.36683L17.1023 8.47277C16.8962 9.22815 16.2065 9.75785 14.8281 9.75785V10.9094L15.0043 10.907C15.8812 10.8811 16.5876 10.6618 17.1202 10.3025L17.8842 9.56152L18.1001 8.31616Z",
    fill: "#2B363D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2742 10.3034C18.8419 10.6869 19.6076 10.9103 20.5662 10.9103V9.75878L20.416 9.75648C19.1372 9.71906 18.4855 9.20203 18.2868 8.47485L17.7692 8.54164L17.2891 9.6396L18.2742 10.3034Z",
    fill: "#2B363D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9497 16.1697C22.3177 16.1697 21.6857 16.3879 21.2038 16.8244C20.7219 17.2609 20.0899 17.4792 19.4579 17.4792M19.4588 17.487C18.8268 17.487 18.1948 17.2688 17.7129 16.8323C17.231 16.3958 16.599 16.1775 15.967 16.1775C15.335 16.1775 14.703 16.3958 14.2212 16.8323C13.7393 17.2688 13.1073 17.487 12.4753 17.487C11.8433 17.487 11.2113 17.2688 10.7294 16.8323C10.2475 16.3958 9.61552 16.1775 8.98352 16.1775C8.35151 16.1775 7.7195 16.3958 7.23764 16.8323C6.75577 17.2688 6.12377 17.487 5.49176 17.487C4.85975 17.487 4.22774 17.2688 3.74588 16.8323C3.26402 16.3958 2.63201 16.1775 2 16.1775",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9497 18.8325C22.3177 18.8325 21.6857 19.0508 21.2038 19.4873C20.7219 19.9238 20.0899 20.142 19.4579 20.142M19.4588 20.1499C18.8268 20.1499 18.1948 19.9316 17.7129 19.4951C17.231 19.0586 16.599 18.8404 15.967 18.8404C15.335 18.8404 14.703 19.0586 14.2212 19.4951C13.7393 19.9316 13.1073 20.1499 12.4753 20.1499C11.8433 20.1499 11.2113 19.9316 10.7294 19.4951C10.2475 19.0586 9.61552 18.8404 8.98352 18.8404C8.35151 18.8404 7.7195 19.0586 7.23764 19.4951C6.75577 19.9316 6.12377 20.1499 5.49176 20.1499C4.85975 20.1499 4.22774 19.9316 3.74588 19.4951C3.26402 19.0586 2.63201 18.8404 2 18.8404",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharca);
export default __webpack_public_path__ + "static/media/Charca.4054b4f040b821064307acd2af9cfbda.svg";
export { ForwardRef as ReactComponent };